import { c as _c } from "react/compiler-runtime";
import type { LitePlaybook, PublicWorkflowKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import useOnboardingKindText from './use-onboarding-kind-text';
export const useGetPlaybookVersionDisplayName = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "onboardingTraceDialog"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  const onboardingKindText = useOnboardingKindText();
  let t1;
  if ($[1] !== onboardingKindText || $[2] !== t) {
    const getPlaybookVersionDisplayName = (playbook, kind) => {
      if (!playbook) {
        return kind ? onboardingKindText(kind) : t(_temp);
      }
      if (playbook.isHidden) {
        return `${playbook.name} (${t(_temp2)})`;
      }
      return `${playbook.name} (v${playbook.version})`;
    };
    t1 = {
      getPlaybookVersionDisplayName
    };
    $[1] = onboardingKindText;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp($) {
  return $.adHocFlow;
}
function _temp2($_0) {
  return $_0.unsavedChanges;
}